import { JBAction } from './actions'
import _ from 'lodash'

const channel = new BroadcastChannel('state-sync')

export const syncMiddleware = store => next => action => {
  const result = next(action)

  // Sync only after these actions
  const syncActions = [
    JBAction.ZOOM_IN,
    JBAction.ZOOM_OUT,
    JBAction.ZOOM_SET,
    JBAction.ZOOM_TO_FIT,
    JBAction.AUTO_LAYOUT_WORKFLOW,
    JBAction.NODE_SELECTED,
    JBAction.LINK_SELECTED,
    JBAction.CELLS_SELECTED,
    JBAction.BLANK_CLICK,
    JBAction.NODES_MOVED,
    JBAction.NODE_DROPPED_FROM_PALETTE,
    JBAction.NODE_NEXT_CONNECTION_CREATED,
    JBAction.NODE_COPIED,
    JBAction.NODE_LINKS_REMOVED,
    JBAction.NODE_REMOVED,
    JBAction.NODE_REPLACE,
    JBAction.LINK_CREATED,
    JBAction.LINK_TARGET_REPLACED,
    JBAction.LINK_LABEL_CHANGED,
    JBAction.LINK_REMOVED,
    JBAction.REMOVE_SELECTION,
    JBAction.PASTE,
    JBAction.CLEAR_WORKFLOW,
    JBAction.NODE_LABEL_CHANGED,
    JBAction.NODE_DESCRIPTION_CHANGED,
    JBAction.NODE_DATA_CHANGED,
    JBAction.NODE_FORMDATA_CHANGED,
    JBAction.NODE_VALIDATION_CHANGED,
    JBAction.BATCH_NODE_VALIDATION_UPDATE,
    JBAction.UNDO,
    JBAction.REDO
  ]

  if (syncActions.includes(action.type)) {
    const state = store.getState()

    // Shallow copy the state and the UI structures that could contain non-serializable DOM elements
    // to prevent circular reference errors or performance overhead during deep-cloning
    const sanitizedState = {
      ...state,
      ui: state.ui
        ? {
            ...state.ui,
            infoPanel: state.ui.infoPanel ? { ...state.ui.infoPanel, target: undefined } : undefined,
            errorNode: state.ui.errorNode ? { ...state.ui.errorNode, target: undefined } : undefined
          }
        : undefined
    }

    const stateToSync = _.cloneDeep(sanitizedState)

    channel.postMessage(stateToSync)
  }

  return result
}

// Listener
export function listenToExternalState(store) {
  channel.onmessage = event => {
    const externalState = event.data
    const storeState = store.getState()

    const externalJourneyId = externalState?.workflow?.journeyId
    const currentJourneyId = storeState?.workflow?.journeyId

    // Only sync if both states have a valid journeyId AND they are the same journey!
    if (externalJourneyId && currentJourneyId && externalJourneyId === currentJourneyId) {
      // Ensure you are only syncing the state when necessary
      if (!_.isEqual(externalState, storeState)) {
        store.dispatch({
          type: 'SET_EXTERNAL_STATE',
          payload: externalState
        })
      }
    }
  }

  // On initial load, broadcast the current state to other tabs
  // const stateToSync = store.getState();
  // channel.postMessage(stateToSync);
}
